module.exports = __webpack_public_path__ + "img/bookshelf21.5c95286c.jpg";